import { DIGITS_PER_DRAW, TICKET_PRICE, TOTAL_NUMBERS } from '../../core/constants/lottery';
import { formatCount, formatCurrency } from '../../core/utils/format';

import './styles/how-it-works.css';

// Flat feature (TSS vite/01 §"Feature folder shape" — single stateless
// surface, so no {contexts, forms, layouts} shape).

const STEPS = [
    {
        icon: '🎯',
        title: 'Elige tu combinado',
        text: `Cualquier número de ${DIGITS_PER_DRAW} dígitos entre 0000 y 9999. Puedes llevar varios de una sola vez.`,
    },
    {
        icon: '💳',
        title: 'Paga en segundos',
        text: `${formatCurrency(TICKET_PRICE)} por número. Sin filas, sin efectivo, sin papeleta que se pierda.`,
    },
    {
        icon: '🎰',
        title: 'Espera la balotera',
        text: 'Cada media hora salen 4 balotas. Si tu combinado coincide, ganas el premio mayor.',
    },
];

export default function HowItWorks() {
    return (
        <section className="how-it-works section">
            <div className="section__head">
                <div>
                    <h2 className="section__title">Cómo se juega</h2>
                    <p className="section__subtitle">
                        {formatCount(TOTAL_NUMBERS)} combinados posibles, un sorteo cada 30 minutos.
                    </p>
                </div>
            </div>

            <ol className="how-it-works__steps">
                {STEPS.map((step, index) => (
                    <li className="how-it-works__step" key={step.title}>
                        <span className="how-it-works__index">{index + 1}</span>
                        <span className="how-it-works__icon" aria-hidden="true">{step.icon}</span>
                        <h3 className="how-it-works__step-title">{step.title}</h3>
                        <p className="how-it-works__text">{step.text}</p>
                    </li>
                ))}
            </ol>
        </section>
    );
}
